import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {getCurrentCartState} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";


interface OwnProps 
{
    extendedStyles?: ProductListProductCountStyles;
}

const mapStateToProps = (state: ApplicationState) => {    
 return{
    totalCountDisplay: getCurrentCartState(state).value?.totalCountDisplay,
 };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasCartLineContext;

export interface ProductListProductCountStyles {
    wrapper?: InjectableCss;
    countText?: TypographyPresentationProps;
    itemsText?: TypographyPresentationProps;
    queryText?: TypographyPresentationProps;
}

export const productCountStyles: ProductListProductCountStyles = {
    wrapper: {
        css: css`
            margin-top: .625rem;
            color: ${themeColors.colorCharcoalGrey};
            font-size: ${themeFontSizes.size14};
            letter-spacing: 0;
            font-family: Lato;
            font-size: 15px;
            font-weight: bold;
            letter-spacing: 0.17px;
            line-height: 18px;
            padding-bottom: 10px;
            margin-bottom: 15px;
            border-bottom: 1px solid #C2D1D9;
        `,
    },
    countText: {
        css: css`
            white-space: nowrap;
        `,
    },
    queryText: {
        css: css`
            white-space: nowrap;
            font-weight: bold;
        `,
    },
};

const styles = productCountStyles;

const CartProductCount: FC<Props> = ({totalCountDisplay}) => {
    if (totalCountDisplay === undefined) {
        return <></>;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
           {(totalCountDisplay === 1 && totalCountDisplay !== undefined)?
                <Typography className="cart-items"> {`${translate("There is")} ${totalCountDisplay} ${translate("item in your cart")}`}</Typography> :
                <Typography className="cart-items"> {`${translate("There are")} ${totalCountDisplay} ${translate("items in your cart")}`}</Typography>
            }
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CartProductCount),
    definition: {
        group: "Basic",
        displayName: "Cart Product Count"
    },
};

export default widgetModule;
